import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setForm } from '../../modules/ChannelForm';
import { ChannelForm, Channel } from '../../core/model';
import * as apiServices from '../../services/apiServices';
import { LoadingSpinnerPage } from '../../components/atomic/Loaders/LoadingSpinner';
import { formatDataToModel } from '../../utils';
import { getResources } from '../../modules/Resource';
import { toast } from 'react-toastify';
import StatusButton from '../../components/molecule/StatusIndicators/StatusButton';
import ChannelNameDialog from '../../components/molecule/Dialogs/ChannelNameDialog';

import Aside from './Aside';
import Main from './Main';
import Wallpaper from './Wallpaper';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 80%;
  margin: auto;
`

const TopContainer = styled.div`

`
const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding-bottom: 90px;
`

const AsideStyled = styled(Aside)`
  width: auto;
  flex: 1;
  margin-bottom: auto;
`
const MainStyled = styled(Main)`
  width: 60%;
  margin-bottom: auto;
`
const WallpaperStyled = styled(Wallpaper)`
`
const StatusButtonStyled = styled(StatusButton)`
  margin: 10px;
  margin-left: auto;
`

class Profile extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isLoading: true,
      enterChannelNameOpen: false,
    }
  }

  async componentDidMount() {
    const { getResources, resourceState, authState, setForm } = this.props;
    try {
      const uid = authState.userData ? authState.userData.user_id : null;
      let data = null;
      if (uid != null) {
        data = await apiServices.getTrainer(uid);
      }
      if (!resourceState.resourceData) {
        await getResources();
      }
      const currentChannel = await formatDataToModel(data, Channel);
      const channelForm = new ChannelForm();
      if (currentChannel) {
        if (!currentChannel.bio) {
          currentChannel.bio = { bio1:'', bio2:'', bio3:'', bio4:'', bio5:'' };
        }
        channelForm.formatForForm(currentChannel);
      }
      setForm(channelForm, true);
      this.setState({
        isLoading: false,
      });
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  save = (params, callback) => {
    const { channelFormState, setForm } = this.props;
    const channelForm = channelFormState.form;
    const origChannel = Object.assign({}, channelForm);
    Object.assign(channelForm, params);
    this.submitForm(channelForm, (setFormOrig, updatedChannel) => {
      if (setFormOrig) {
        Object.assign(channelForm, origChannel);
      }

      if (updatedChannel) {
        const currentChannel = formatDataToModel(updatedChannel, Channel);
        const channelForm = new ChannelForm();
        if (!currentChannel.bio) {
          currentChannel.bio = { bio1:'', bio2:'', bio3:'', bio4:'', bio5:'' };
        }
        channelForm.formatForForm(currentChannel);
        setForm(channelForm, true);
      }
      else {
        setForm(channelForm);
      }

      if (callback) {
        callback();
      }
    });
  }

  submitForm = (form, callback) => {
    const uid = form.user_id;
    apiServices.updateTrainer(uid, form.formatforDB())
    .then(response => {
      toast.success('Successfully updated channel');
      callback(false, response);
    })
    .catch(e => {
      console.log('component: ',this,e);
      toast.error(
        e.response.data.ValidationError ? e.response.data.ValidationError : e.message
      );
      // callback with true to reset form to original values
      callback(true);
    })
  }

  openChannelNameDialog = () => this.setState({ enterChannelNameOpen: true });
  closeChannelNameDialog = () => this.setState({ enterChannelNameOpen: false });
  
  render() {
    const { channelFormState } = this.props;
    const { isLoading, enterChannelNameOpen } = this.state
    const channelForm = channelFormState.form;
    return isLoading ? (
      <LoadingSpinnerPage/>
    ) : (
      <React.Fragment>
        <StatusButtonStyled value={channelForm} header="Complete Channel" subheader="Channel is complete when the tasks below are complete." />
        <Container>
          <TopContainer>
            <WallpaperStyled
              data={channelForm}
              onSubmit={this.save}
              openChannelNameDialog={this.openChannelNameDialog}/>
          </TopContainer>
          <BottomContainer>
            <AsideStyled
              data={channelForm}
              onSubmit={this.save}
              openChannelNameDialog={this.openChannelNameDialog}/>
            <MainStyled
              data={channelForm}
              onSubmit={this.save}
              openChannelNameDialog={this.openChannelNameDialog}/>
          </BottomContainer>
        </Container>
        {
          enterChannelNameOpen &&
          <ChannelNameDialog
            open={enterChannelNameOpen}
            title="Enter Channel Name"
            content="Please enter a name for your channel before editing other fields."
            showCancel={false}
            handleAgree={this.closeChannelNameDialog}
            handleClose={this.closeChannelNameDialog}
            agreeText="OK"
          />
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    resourceState: state.resourceState,
    authState: state.authState,
    channelFormState: state.channelFormState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    setForm: setForm,
  }, dispatch)
}

Profile.propTypes = {

};

export default connect(mapStateToProps,mapDispatchToProps)(Profile);
